import pages from './pages';

const platformComponents = ['aggregation', 'valuations', 'assessments'].map(i => pages[i]);

export default platformComponents;



// WEBPACK FOOTER //
// ./src/services/platformComponents.js